import { useLoggedinUser } from "./useLoggedinUser";
import useSWR from "swr";
import { teamInvitesClient } from "../clients";

const fetcher = async (): Promise<any> => {
  try {
    const { data } = await teamInvitesClient.getInvites();
    return data;
  } catch (err) {
    throw err;
  }
}

export const useTeamInvites = () => {
  const { data: user } = useLoggedinUser();
  const { data: response, error, isValidating, mutate } = useSWR(user?.verified ? `v1/team-invitations/invites` : null, fetcher);

  const data = response || [];

  return {
    data,
    error,
    isLoading: !response && !error,
    isValidating,
    mutate,
  }
}
